import { render } from "./AppFormView_1300.vue?vue&type=template&id=471d6106"
import script from "./AppFormView_1300.vue?vue&type=script&lang=js"
export * from "./AppFormView_1300.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__